export const PRODUCTION_SMALL = 'PRODUCTION_SMALL';
export const PRODUCTION_LARGE = 'PRODUCTION_LARGE';
export const VIOLET = 'VIOLET';
